/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 */
import * as types from "./types";

const mutations = {
  [types.SET_BUY_PANEL_PRODUCT_IMAGE](state, { recipeId, data }) {
    state.productImages.buyPanel = {
      ...state.productImages.buyPanel,
      [recipeId]: data
    };
  },
  [types.SET_FAVORITES_PRODUCT_IMAGE](state, { recipeId, data }) {
    state.productImages.favorites = {
      ...state.productImages.favorites,
      [recipeId]: data
    };
  },
  [types.SET_START_OVER_PRODUCT_IMAGE](state, { recipeId, data }) {
    state.productImages.startOver = {
      ...state.productImages.startOver,
      [recipeId]: data
    };
  },
};

export default mutations;
